"use client";

import { createContext, useContext, type ReactNode } from "react";

interface AudienceAnalyticsContextValue {
  username?: string;
}

const AudienceAnalyticsContext = createContext<AudienceAnalyticsContextValue>({
  username: undefined,
});

interface AudienceAnalyticsProviderProps {
  username?: string;
  children: ReactNode;
}

/**
 * Provider for audience analytics context
 * Wraps pages where audience members view creator profiles
 * Automatically injects username into all audience analytics events
 */
export function AudienceAnalyticsProvider({
  username,
  children,
}: AudienceAnalyticsProviderProps) {
  return (
    <AudienceAnalyticsContext.Provider value={{ username }}>
      {children}
    </AudienceAnalyticsContext.Provider>
  );
}

/**
 * Hook to access audience analytics context
 * Returns the current creator's username for analytics tracking
 */
export function useAudienceAnalyticsContext() {
  return useContext(AudienceAnalyticsContext);
}
